import {AuthModel} from './_models'
import { getAuth as getSecureAuth, setAuth as setSecureAuth, removeAuth as removeSecureAuth, AUTH_LOCAL_STORAGE_KEY } from '../../../utils/secureStorage'

// Use secure storage functions that implement enhanced security measures
const getAuth = (): AuthModel | undefined => {
  return getSecureAuth()
}

const setAuth = (auth: AuthModel): void => {
  setSecureAuth(auth)
}

const removeAuth = (): void => {
  removeSecureAuth()
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function setupAxios(axios: any): void {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.token) {
        config.headers.Authorization = `Bearer ${auth.token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
